import { RECENT_DAYS } from "../firestore/firestoreService";

const LOAD_APP_MODE = "LOAD_APP_MODE";
const SET_COOKIE_CONSENT = "SET_COOKIE_CONSENT";
const APP_ERROR = "APP_ERROR";
const SET_RESPONSIVE = "SET_RESPONSIVE";
const LOAD_VISITOR_ID = "LOAD_VISITOR_ID";
const LOAD_ADMIN_KEY = "LOAD_ADMIN_KEY";

export function loadAppMode(payload) {
  return {
    type: LOAD_APP_MODE,
    payload: payload,
  };
}

export function setCookieConsent(cookieConsent) {
  return {
    type: SET_COOKIE_CONSENT,
    payload: cookieConsent,
  };
}

export function appError(error) {
  return {
    type: APP_ERROR,
    payload: error,
  };
}

export function setResponsive(payload) {
  return {
    type: SET_RESPONSIVE,
    payload: payload,
  };
}

export function loadVisitorId(id) {
  return {
    type: LOAD_VISITOR_ID,
    payload: id,
  };
}

export function loadAdminKey(bool) {
  return {
    type: LOAD_ADMIN_KEY,
    payload: bool,
  };
}

const APP_INITIAL_STATE = {
  appMode: {
    isLive: true,
    isMaintenance: false,
    isLoaded: false,
    stats: {
      pricing: [],
    },
    release: "",
    isAllowFreebies: false,
    recentDays: RECENT_DAYS,
  },
  appError: null,
  isCookieConsent: false,
  responsive: {
    isComputer: false,
    isTablet: false,
    isMobile: false,
    isPortrait: false,
  },
  visitorId: null,
  adminKey: false,
};

export default function appReducer(
  state = APP_INITIAL_STATE,
  { type, payload }
) {
  switch (type) {
    case LOAD_APP_MODE:
      return {
        ...state,
        appMode: {
          isLive: payload.isLive,
          // isMaintenance: payload.isMaintenance,
          isLoaded: payload.isLoaded,
          release: payload.release,
          isAllowFreebies: payload.isAllowFreebies,
          recentDays: payload.recentDays,
          stats: payload.stats,
        },
      };
    case SET_COOKIE_CONSENT:
      return {
        ...state,
        isCookieConsent: payload,
      };
    case APP_ERROR:
      return {
        ...state,
        appError: payload,
      };
    case SET_RESPONSIVE:
      return {
        ...state,
        responsive: payload,
      };
    case LOAD_VISITOR_ID:
      return {
        ...state,
        visitorId: payload,
      };
    case LOAD_ADMIN_KEY:
      return {
        ...state,
        adminKey: payload,
      };
    default:
      return state;
  }
}
